import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Loader } from "../common";
import {
  PAYMENT_TYPES,
  resetReport,
  fetchReports,
  getFeeAccounts,
} from "../../actions";
import { convertToCurrencyFormat } from "../../helpers/Utils";
import moment from "moment";
import ReactExport from "react-export-excel";
import StyleConstants from "../../shared/constants/styleConstants/styles.json";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const customDropdownStyles = {
  control: (base) => ({
    ...base,
    height: 35,
    width: 200,
    backgroundColor: "white",
    border: "1px solid #CDCFD6",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 35,
  }),
  valueContainer: (base) => ({
    ...base,
    height: 35,
    overflow: "auto",
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
    color: state.isFocused ? "#FFF" : "#000",
    backgroundColor: state.isFocused && "#3994AE",
  }),
};

const selected = {
  borderBottom: `3px solid ${StyleConstants.color.darkBlue}`,
  color: StyleConstants.color.darkBlue,
  fontSize: 20,
  opacity: 1,
  height: 40,
  paddingTop: 15,
  cursor: "pointer",
  marginRight: 20,
  fontFamily: "'Poppins', sans-serif",
};
const unselected = {
  fontSize: 20,
  color: "#c4c4c4",
  opacity: 1,
  height: 40,
  paddingTop: 15,
  cursor: "pointer",
  marginRight: 20,
  fontFamily: "'Poppins', sans-serif",
};

class Report extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedFeeAccounts: this.props.feeAccounts,
      startDate: undefined,
      endDate: undefined,
      selectedAccountant: null,
      selectedPaymentType: null,
      selectedCampus: null,
      hasAccess: true,
      showDaywiseReport: false,
      selectedInstitutesTagIds: [],
    };
  }
  async componentDidMount() {
    await this.props.resetReport();
    await this.props.getFeeAccounts().then((data) => {
      this.setState({ hasAccess: data.success });
    });
    this.setState({ selectedFeeAccounts: this.props.feeAccounts });
  }

  renderMultiSelect(options, selectedOption, key, placeholder) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: 5,
        }}
      >
        {key !== "selectedFeeAccounts" && (
          <div style={{ marginRight: "auto", fontSize: 14 }}>
            {placeholder}:
          </div>
        )}
        <Select
          value={selectedOption}
          onChange={(option) => this.setState({ [key]: option })}
          options={options}
          placeholder={placeholder}
          styles={customDropdownStyles}
          isSearchable
          isMulti
          isClearable
        />
      </div>
    );
  }

  renderSingleSelect(options, selectedOption, key, placeholder) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: 5,
        }}
      >
        <div style={{ marginRight: "auto", fontSize: 14 }}>{placeholder}:</div>
        <Select
          value={selectedOption}
          onChange={(option) => this.setState({ [key]: option })}
          options={options}
          placeholder={placeholder}
          styles={customDropdownStyles}
          isSearchable
          isClearable
        />
      </div>
    );
  }

  renderInputs() {
    const { feeAccounts } = this.props;
    const { startDate, endDate, selectedFeeAccounts, showDaywiseReport } =
      this.state;
    return (
      <div
        style={{
          flex: 1,
          padding: 15,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderBottom: "1px solid gray",
          fontFamily: "'Poppins', sans-serif",
          color: StyleConstants.color.darkBlue,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ marginRight: 10 }}>Select Account:</div>
          {this.renderMultiSelect(
            feeAccounts,
            selectedFeeAccounts,
            "selectedFeeAccounts",
            "Select Fee Accounts"
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", marginLeft: 20 }}>
          <div style={{ marginRight: 10 }}>Start Date:</div>
          <input
            type="date"
            value={startDate}
            onChange={(event) =>
              this.setState({ startDate: event.target.value })
            }
          />
        </div>
        <div style={{ display: "flex", alignItems: "center", marginLeft: 20 }}>
          <div style={{ marginRight: 10 }}>End Date:</div>
          <input
            type="date"
            value={endDate}
            onChange={(event) => this.setState({ endDate: event.target.value })}
          />
        </div>
        <div
          className="Button Primary-Button"
          style={{ marginLeft: 20, width: 100, fontWeight: "normal" }}
          onClick={() =>
            this.props.fetchReports(
              selectedFeeAccounts.map((account) => account.id),
              startDate,
              endDate,
              showDaywiseReport
            )
          }
        >
          Fetch
        </div>
      </div>
    );
  }

  renderDashboard() {
    const { payments } = this.props;
    const paymentSplit = payments.reduce((paymentSplit, payment) => {
      paymentSplit[payment.payment_type] =
        (parseInt(paymentSplit[payment.payment_type], 10) || 0) +
        payment.amount;
      return paymentSplit;
    }, {});
    return (
      <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
        <div style={{ width: "100%", padding: 20 }}>
          <div
            style={{
              fontSize: 23,
              color: "#005060",
              fontFamily: "'Poppins', sans-serif",
              color: StyleConstants.color.darkBlue,
            }}
          >
            Dashboard
          </div>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {Object.keys(paymentSplit).map((paymentType) => (
              <div
                style={{
                  margin: 15,
                  width: 200,
                  padding: 20,
                  borderRadius: 4,
                  fontFamily: "'Poppins', sans-serif",
                  boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
                  backgroundColor: "#ffffff",
                }}
              >
                <div
                  style={{
                    fontSize: 16,
                    textAlign: "center",
                    color: "gray",
                  }}
                >
                  {paymentType}
                </div>
                <div
                  style={{
                    fontSize: 23,
                    marginTop: 10,
                    color: StyleConstants.color.darkBlue,
                    textAlign: "center",
                  }}
                >
                  {convertToCurrencyFormat(paymentSplit[paymentType])}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  renderFilters() {
    const {
      selectedPaymentType,
      selectedAccountant,
      selectedCampus,
      selectedInstitutesTagIds,
    } = this.state;
    const { accountants, campuses, institutesTags, isFinance } = this.props;
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          margin: "20px 0px",
          justifyContent: "center",
          fontFamily: "'Poppins', sans-serif",
          color: StyleConstants.color.darkBlue,
        }}
      >
        {this.renderSingleSelect(
          Object.keys(PAYMENT_TYPES).map((mode) => {
            return { value: PAYMENT_TYPES[mode], label: mode };
          }),
          selectedPaymentType,
          "selectedPaymentType",
          "Payment Type"
        )}
        {campuses.length > 1
          ? this.renderSingleSelect(
              campuses,
              selectedCampus,
              "selectedCampus",
              "Select Campus"
            )
          : this.setState({ selectedCampus: campuses[0] })}
        {!isFinance &&
          this.renderSingleSelect(
            accountants,
            selectedAccountant,
            "selectedAccountant",
            "Select Accountant"
          )}
        {institutesTags.length > 0 &&
          this.renderMultiSelect(
            institutesTags,
            selectedInstitutesTagIds,
            "selectedInstitutesTagIds",
            "Select Tags"
          )}
      </div>
    );
  }

  renderReport() {
    const { payments, feeAccounts } = this.props;
    const {
      selectedAccountant,
      selectedPaymentType,
      selectedCampus,
      selectedInstitutesTagIds,
    } = this.state;
    let filteredPayments = payments;
    if (selectedPaymentType) {
      filteredPayments = payments.filter(
        (payment) => payment.payment_type === selectedPaymentType.label
      );
    }
    if (selectedCampus) {
      filteredPayments = payments.filter(
        (payment) => payment.campus_id === selectedCampus.value
      );
    }
    if (selectedAccountant) {
      filteredPayments = filteredPayments.filter(
        (payment) =>
          Number(payment.accountant_id) === Number(selectedAccountant.value)
      );
    }
    if (selectedInstitutesTagIds && selectedInstitutesTagIds.length > 0) {
      const tagsList = selectedInstitutesTagIds.map((tag) => {
        return tag.value;
      });
      filteredPayments = filteredPayments.filter((payment) =>
        payment.student_tags.some((tag) => tagsList.includes(tag.value))
      );
    }
    const totalPayment = filteredPayments.reduce(
      (sum, payment) => sum + (parseInt(payment.amount, 10) || 0),
      0
    );
    return (
      <div
        style={{
          display: "block",
          justifyContent: "center",
          overflowX: "auto",
        }}
      >
        <style>
          {`
          table {
            border-spacing: 0;
            width: 100%;
            background: #ffffff;
            box-shadow: 1px 2px 6px #8b9daf26;
          }
          th {
            padding: 10px;
            font-family: 'Poppins', sans-serif;
            font-weight: normal;
            font-size: 14px;
          }
          td {
            padding: 10px;
            font-family: 'Poppins', sans-serif;
            font-size: 14px;
          }
          thead {
            background-color: #edf1f8;
            color: ${StyleConstants.color.darkBlue};
          }
          tbody {
            color: gray;
          }
        `}
        </style>
        <div
          style={{
            width: "100%",
            margin: 15,
            display: "flex",
            borderRadius: 4,
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {!filteredPayments?.length ? (
            <div
              style={{
                textAlign: "center",
                color: StyleConstants.color.darkBlue,
                fontFamily: "'Poppins', sans-serif",
                fontSize: 20,
                margin: 30,
              }}
            >
              No Payments present
            </div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th style={{ textAlign: "right" }}>S.No</th>
                  <th style={{ textAlign: "left" }}>Payment date</th>
                  <th style={{ textAlign: "left" }}>Account</th>
                  <th style={{ textAlign: "right" }}>Student ID</th>
                  <th style={{ textAlign: "left" }}>Student Name</th>
                  <th style={{ textAlign: "left" }}>Classroom</th>
                  <th style={{ textAlign: "left" }}>Fee</th>
                  <th style={{ textAlign: "left" }}>Mode</th>
                  <th style={{ textAlign: "right" }}>Cheque/DD No</th>
                  <th style={{ textAlign: "right" }}>Ref No</th>
                  <th style={{ textAlign: "right" }}>Card No</th>
                  <th style={{ textAlign: "right" }}>Batch No</th>
                  <th style={{ textAlign: "right" }}>Accountant</th>
                  <th style={{ textAlign: "right" }}>Amount</th>
                </tr>
              </thead>
              <tbody style={{ padding: 20 }}>
                {filteredPayments.map((payment, index) => {
                  const feeAccount = feeAccounts.find(
                    (account) =>
                      Number(account.id) === Number(payment.fee_account_id)
                  );
                  return (
                    <tr key={payment.id}>
                      <td style={{ textAlign: "right" }}>{index + 1}</td>
                      <td style={{ textAlign: "left" }}>
                        {moment(payment.payment_date).format("DD MMM 'YY")}
                      </td>
                      <td style={{ textAlign: "left" }}>{feeAccount?.name}</td>
                      <td style={{ textAlign: "right" }}>
                        {payment.student_id}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {payment.student_name}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {payment.classroom_name}
                      </td>
                      <td style={{ textAlign: "left" }}>{payment.fee_name}</td>
                      <td style={{ textAlign: "left" }}>
                        {payment.payment_type}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {payment.payment_type === "CHEQUE"
                          ? payment.cheque_number
                          : payment.payment_type === "DD"
                          ? payment.dd_number
                          : "-"}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {payment.ref_no ? payment.ref_no : "-"}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {payment.card_no ? payment.card_no : "-"}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {payment.batch_no ? payment.batch_no : "-"}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {payment.accountant_name}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {convertToCurrencyFormat(payment.amount)}
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td
                    colSpan={12}
                    style={{
                      borderTop: "1px dashed #c8c8c8",
                      color: StyleConstants.color.darkBlue,
                    }}
                  >
                    Total
                  </td>
                  <td
                    style={{
                      borderTop: "1px dashed #c8c8c8",
                      color: StyleConstants.color.darkBlue,
                      textAlign: "right",
                    }}
                  >
                    {convertToCurrencyFormat(totalPayment)}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          <div style={{ paddingTop: "25px", paddingLeft: "950px" }}>
            {filteredPayments.length > 0 &&
              this.renderDownload(filteredPayments)}
          </div>
        </div>
      </div>
    );
  }

  renderDownload(dataset) {
    return (
      <ExcelFile
        element={
          <div
            className="Button Primary-Button"
            style={{
              marginLeft: 20,
              width: 100,
              fontWeight: "normal",
              fontFamily: "'Poppins', sans-serif",
              padding: "0 5px",
            }}
          >
            {" "}
            Download .xls
          </div>
        }
      >
        <ExcelSheet data={dataset} name="Employees">
          <ExcelColumn label="PaymentId" value="id" />
          <ExcelColumn label="AccountId" value="accountant_id" />
          <ExcelColumn label="Date" value="payment_date" />
          <ExcelColumn label="ID" value="student_id" />
          <ExcelColumn label="StudentName" value="student_name" />
          <ExcelColumn label="Classroom" value="classroom_name" />
          <ExcelColumn label="Fee" value="fee_name" />
          <ExcelColumn label="Mode" value="payment_type" />
          <ExcelColumn label="ChequeNumber" value="cheque_number" />
          <ExcelColumn label="DDNumber" value="dd_number" />
          <ExcelColumn label="Amount" value="amount" />
          <ExcelColumn label="ReceiptNumber" value="receipt_number" />
          <ExcelColumn label="ReferenceNumber" value="ref_no" />
          <ExcelColumn label="CardNumber" value="card_no" />
          <ExcelColumn label="BatchNumber" value="batch_no" />
          <ExcelColumn label="POSMachineID" value="machine_id" />
        </ExcelSheet>
      </ExcelFile>
    );
  }

  renderTabs() {
    const { showDaywiseReport } = this.state;
    return (
      <div
        style={{
          display: "flex",
          width: "80%",
          marginBottom: 10,
        }}
      >
        <div
          style={showDaywiseReport ? unselected : selected}
          onClick={() => {
            this.setState({
              showDaywiseReport: false,
            });
            window.scrollTo(0, 0);
          }}
        >
          Fee Report
        </div>
        <div
          style={showDaywiseReport ? selected : unselected}
          onClick={() => {
            this.setState({
              showDaywiseReport: true,
            });

            window.scrollTo(0, 0);
          }}
        >
          Daywise Consolidated Report
        </div>
      </div>
    );
  }

  addMissingDataPoints(paymentData) {
    var dataPoints = paymentData;
    var missingDates = dataPoints
      .sort(function (a, b) {
        return Date.parse(a.date) - Date.parse(b.date);
      })
      .reduce(
        (function (hash) {
          return function (p, c) {
            var missingDaysNo =
              (Date.parse(c.date) - hash.prev) / (1000 * 3600 * 24);
            if (hash.prev && missingDaysNo > 1) {
              for (var i = 1; i < missingDaysNo; i++)
                p.push(moment(hash.prev).add(i, "days").format("YYYY-MM-DD"));
            }
            hash.prev = Date.parse(c.date);
            return p;
          };
        })(Object.create(null)),
        []
      );
    for (var j = 0; j < missingDates.length; j++) {
      dataPoints.push({
        date: missingDates[j],
        payment_type: "CASH",
        amount: 0,
      });
    }
    dataPoints.sort(function (a, b) {
      return Date.parse(a.date) - Date.parse(b.date);
    });
    let tableData = {};
    dataPoints.map((dataPoint) => {
      if (!tableData[dataPoint.date]) {
        tableData[dataPoint.date] = {};
      }
      tableData[dataPoint.date][dataPoint.payment_type]
        ? (tableData[dataPoint.date][dataPoint.payment_type] +=
            dataPoint.amount)
        : (tableData[dataPoint.date][dataPoint.payment_type] =
            dataPoint.amount);
    });
    Object.keys(tableData).map((date) => {
      tableData[date].total = Object.values(tableData[date]).reduce(
        (a, b) => a + b
      );
    });
    return tableData;
  }

  renderDaywiseReport() {
    const filteredData = this.addMissingDataPoints(
      this.props.daywiseReportData
    );
    if (!Object.keys(filteredData)?.length) {
      return (
        <div
          style={{
            textAlign: "center",
            color: StyleConstants.color.darkBlue,
            fontFamily: "'Poppins', sans-serif",
            fontSize: 20,
            margin: 30,
          }}
        >
          No Payment Data present
        </div>
      );
    }
    return (
      <div style={{ display: "flex", justifyContent: "center", margin: 30 }}>
        <style>
          {`
          table {
            border-spacing: 0;
            width: 100%;
            background: #ffffff;
            box-shadow: 1px 2px 6px #8b9daf26;
          }
          th {
            padding: 10px;
            font-family: 'Poppins', sans-serif;
            font-weight: normal;
            font-size: 14px;
          }
          td {
            padding: 10px;
            font-family: 'Poppins', sans-serif;
            font-size: 14px;
          }
          thead {
            background-color: #edf1f8;
            color: ${StyleConstants.color.darkBlue};
          }
          tbody {
            color: gray;
          }
        `}
        </style>
        <table>
          <thead>
            <tr>
              <th style={{ textAlign: "left" }}>Date</th>
              {Object.keys(PAYMENT_TYPES).map((paymentType) => {
                return <th style={{ textAlign: "right" }}>{paymentType}</th>;
              })}
              <th
                style={{
                  textAlign: "right",
                  borderLeft: "1px dashed #c8c8c8",
                }}
              >
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(filteredData).map((date) => {
              return (
                <tr>
                  <td>{moment(date).format("DD MMM 'YY")}</td>
                  {Object.keys(PAYMENT_TYPES).map((paymentType) => {
                    return (
                      <td style={{ textAlign: "right" }}>
                        {convertToCurrencyFormat(
                          filteredData[date][paymentType] || 0
                        )}
                      </td>
                    );
                  })}
                  <td
                    style={{
                      textAlign: "right",
                      borderLeft: "1px dashed #c8c8c8",
                    }}
                  >
                    {convertToCurrencyFormat(filteredData[date]["total"])}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  renderNoDataMessage() {
    return (
      <div
        style={{
          textAlign: "center",
          color: StyleConstants.color.darkBlue,
          fontFamily: "'Poppins', sans-serif",
          fontSize: 20,
          margin: 30,
        }}
      >
        Please Fetch Data!
      </div>
    );
  }

  renderScreen() {
    if (this.state.showDaywiseReport) {
      return (
        <div style={{ padding: "0px 50px 50px 50px" }}>
          {this.renderTabs()}
          {this.renderInputs()}
          {!this.props.daywiseReportData && this.renderNoDataMessage()}
          {this.props.daywiseReportData && this.renderDaywiseReport()}
        </div>
      );
    }
    return (
      <div style={{ padding: "0px 50px 50px 50px" }}>
        {this.renderTabs()}
        {this.renderInputs()}
        {this.props.payments &&
          this.props.payments.length > 0 &&
          this.renderDashboard()}
        {this.renderFilters()}
        {!this.props.payments && this.renderNoDataMessage()}
        {this.props.payments && this.renderReport()}
      </div>
    );
  }

  noPermission() {
    return (
      <div
        style={{
          paddingTop: 200,
          paddingLeft: 300,
          width: "100%",
          backgroundColor: "#F5F8FA",
          fontSize: "20px",
        }}
      >
        <span style={{ borderStyle: "solid", padding: "10px" }}>
          You dont have permission to access to this page{" "}
        </span>
      </div>
    );
  }

  render() {
    const { hasAccess } = this.state;
    const { isLoading } = this.props;
    if (isLoading) {
      return <Loader />;
    }
    return hasAccess ? this.renderScreen() : this.noPermission();
  }
}

Report.defaultProps = {
  isLoading: false,
  feeAccounts: [],
  accountants: [],
  campuses: [],
  institutesTags: [],
};

Report.propTypes = {
  isLoading: PropTypes.bool,
  feeAccounts: PropTypes.array,
  campuses: PropTypes.array,
  institutesTags: PropTypes.array,
};

const mapStateToProps = ({ report, home }) => ({
  payments: report.payments,
  isLoading: report.isLoading,
  feeAccounts: report.feeAccounts,
  accountants: report.accountants,
  campuses: report.campuses,
  daywiseReportData: report.daywiseReportData,
  institutesTags: home.institutesTags,
  isFinance: home.isFinance,
});

export default connect(mapStateToProps, {
  resetReport,
  fetchReports,
  getFeeAccounts,
})(Report);
